function getUserAgentVersion(agentName) {
    var userAgent = navigator.userAgent;
    var parsed = userAgent.match(new RegExp(agentName + '/(\\d+)'));
    if (parsed) {
        return parseInt(parsed[1]);
    } else {
        return 0;
    }
}